// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3InA-","type":"styles_type__xQYkv","choices":"styles_choices__2Abu2"};